import { BaseCharge } from "./baseCharge";
import { LateCancelCharge } from "./lateCancelCharge";
import { NetTerms } from "./netTerms";
import { DisputeTerms } from "./disputeTerms";
import { Credits } from "./credit";
import PropTypes from "prop-types";
import { ShiftCharge } from "./shiftCharge";
import styled from "styled-components";
import { SentHomeChargeHours } from "./sentHomeCharge";
import { ExtraTimePayEditAccessSwitch } from "./extraTimePayEditAccessSwitch";
import { Stack } from "@mui/material";
import { useGetQualificationsForWorkplaceType } from "@src/appV2/Admin/WorkplaceTypes/api/useGetQualificationsForWorkplaceType";
import { useSelector } from "react-redux";
import { SessionType } from "@src/modules/interface";

const Container = styled.div`
  margin: 20px 0;

  .content {
    margin-left: 10px;
  }
`;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'hcfId' implicitly has an 'any' type.
function FacilityBilling({ hcfId, hcfType, updateFacility }) {
  const { profile } = useSelector((state: SessionType) => state.session);
  const { qualifications } = useGetQualificationsForWorkplaceType({
    workplaceTypeName: hcfType,
    workplaceId: profile.userId,
  });

  return (
    <Container>
      <h4>Workplace Billing</h4>
      <Stack spacing={2} className="content">
        <BaseCharge
          hcfId={hcfId}
          updateFacility={updateFacility}
          hcfType={hcfType}
          qualifications={qualifications}
        />
        <ShiftCharge
          hcfId={hcfId}
          hcfType={hcfType}
          updateFacility={updateFacility}
          qualifications={qualifications}
        />
        <LateCancelCharge hcfId={hcfId} updateFacility={updateFacility} />
        <SentHomeChargeHours hcfId={hcfId} updateFacility={updateFacility} />
        <NetTerms hcfId={hcfId} updateFacility={updateFacility} />
        <DisputeTerms hcfId={hcfId} updateFacility={updateFacility} />
        <Credits hcfId={hcfId} />
        <ExtraTimePayEditAccessSwitch />
      </Stack>
    </Container>
  );
}

FacilityBilling.propTypes = {
  hcfId: PropTypes.string,
  hcfType: PropTypes.string,
  updateFacility: PropTypes.func,
};

export { FacilityBilling };
